module.exports = __webpack_public_path__ + "static/img/jieshao.6a7c59bb.png";